import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=37eab5aa&scoped=true&"
import script from "./DynamicForm.vue?vue&type=script&lang=js&"
export * from "./DynamicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eab5aa",
  null
  
)

export default component.exports